// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1DGh0","stretching":"styles_stretching__3pbcu"};